export interface iHomeIcon {
    isActive?: boolean;
}

export const Home = (props: iHomeIcon) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill={props.isActive ? "#1F1F1F" : "none"}>
            <path d="M0 0h24v24H0z" fill="none"/>
            <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" stroke={props.isActive ? "#1F1F1F" : "#808080"} strokeWidth="2" />
        </svg>
    );
  };

